import { Container } from 'pixi.js';
import { CollectEventProgressBarMainMenuLayout } from '../../../../layouts/collectEvent/CollectEventProgressBarMainMenuLayout';
import type { CollectionEventConfig } from '../types';
import { CollectionTokenIconView } from './CollectionTokenIconView';
import { getCollectionEventRewardProgress } from '../model/collectionEventUtils';
import { setTextAsTimerCountdown } from '../../../utils/pixi/setTextAsTimerCountdown';
import { createInventoryItemViews } from '../../../views/InventoryItemAmountView';
import { getTimeLimitHandler } from '../../../libs/timeLimit/getTimeLimitHandler';

export class CollectionEventProgressStaticProgressBarView extends Container {
  public readonly layout = new CollectEventProgressBarMainMenuLayout();

  constructor(private readonly eventInstance: CollectionEventConfig) {
    super();
    this.init();
  }

  private init(): void {
    const { tokenSlot, progressBarFill, progressBarEmpty, progressText, root, rewardSlot } = this.layout;

    root.props({
      parent: this,
    });

    new CollectionTokenIconView(this.eventInstance.visuals).props({
      parent: tokenSlot,
    });

    const progress = getCollectionEventRewardProgress(this.eventInstance, this.eventInstance.tokensLastSeen);

    progressBarFill.width = Math.round(progressBarEmpty.width * (progress.progress / progress.target));
    progressText.text = `${progress.progress}/${progress.target}`;

    setTextAsTimerCountdown(this.layout.timerText, getTimeLimitHandler(this.eventInstance.timeLimit).getEndDate());

    createInventoryItemViews(progress.rewards).forEach((view) => {
      view.props({ parent: rewardSlot });
    });
  }
}
